import { render, staticRenderFns } from "./Specificationone.vue?vue&type=template&id=b123e2f2&scoped=true&"
import script from "./Specificationone.vue?vue&type=script&lang=js&"
export * from "./Specificationone.vue?vue&type=script&lang=js&"
import style0 from "./Specificationone.vue?vue&type=style&index=0&id=b123e2f2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b123e2f2",
  null
  
)

export default component.exports